import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Gift } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export default function Beneficios() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/benefits").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="space-y-4" data-testid="beneficios-page">
      <h1 className="font-display font-semibold text-xl text-[hsl(var(--primary))]">Convênios</h1>
      <p className="text-sm text-muted-foreground">Convênios e descontos exclusivos para alunos CEAP BRASIL.</p>
      {items.length === 0 ? <EmptyState icon={Gift} title="Nenhum convênio cadastrado" />
        : items.map(b => (
          <Card key={b.id} className="rounded-xl">
            <CardContent className="p-4 flex items-start gap-3">
              <div className="w-12 h-12 rounded-xl bg-[hsl(var(--gold)/0.18)] text-[hsl(var(--gold-foreground))] flex items-center justify-center">
                <Gift className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-display font-semibold text-[hsl(var(--primary))]">{b.name}</h3>
                  {b.discount && <Badge className="bg-[hsl(var(--gold)/0.2)] text-[hsl(var(--gold-foreground))] border-[hsl(var(--gold)/0.4)]">{b.discount}</Badge>}
                </div>
                <p className="text-xs text-muted-foreground capitalize">{b.category} • {b.cidade}/{b.estado}</p>
                <p className="text-sm mt-1">{b.description}</p>
                {b.instructions && <p className="text-xs text-muted-foreground mt-2"><strong className="text-foreground">Como usar:</strong> {b.instructions}</p>}
              </div>
            </CardContent>
          </Card>
        ))}
    </div>
  );
}
